import { yupResolver } from '@hookform/resolvers/yup'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material'
import { useConfirm } from 'material-ui-confirm'
import React, { FunctionComponent, useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'

import useOperaciones from '../../../../base/hooks/useOperaciones'
import { actionForm } from '../../../../interfaces'
import { notError, notSuccess } from '../../../../utils/notification'
import { swalException } from '../../../../utils/swal'
import { apiMonedaActualizar } from '../../api/apiMonedaActualizar'

import { monedaInputValidator } from '../../validator/monedaInputValidator'
import MonedaForm from './MonedaForm'
import {
  MONEDA_DEFAULT,
  MonedaApiInputProps,
  MonedaInputProps,
  MonedaPrecioApiInputProps,
  MonedaProps,
} from '../../../../interfaces/monedaPrecio.ts'

interface OwnProps {
  id: string
  keepMounted: boolean
  input: MonedaProps | null
  open: boolean
  onClose: (value?: MonedaProps) => void
}

type Props = OwnProps

/**
 * Actualización de la moneda
 * @param props
 * @constructor
 */
const MonedaActualizarDialog: FunctionComponent<Props> = (props) => {
  const { onClose, open, id, keepMounted, input, ...other } = props

  const [formLoading, setFormLoading] = useState<boolean>(false)

  const {
    articuloMoneda: { monedaPrimaria },
  } = useOperaciones()

  const confirm = useConfirm()

  const form = useForm<MonedaInputProps>({
    defaultValues: MONEDA_DEFAULT,
    resolver: yupResolver(monedaInputValidator),
  })

  /**
   * Actualizacion de monedas
   * @param data
   */
  const onSubmit = async (data: MonedaInputProps) => {
    if (monedaPrimaria._id === input?._id) {
      if (data.tipoCambio !== 1) {
        notError('El tipo de cambio para la moneda principal debe ser siempre 1')
        return
      }

      if (data.tipoCambioCompra !== 1) {
        notError('El tipo de cambio compra para la moneda principal debe ser siempre 1')
        return
      }
    }
    const { confirmed } = await confirm()
    if (!confirmed) return

    if (input) {
      setFormLoading(true)
      const monedaInput: MonedaApiInputProps = {
        codigoSinMoneda: data.sinMoneda!.codigoClasificador,
        sigla: data.sigla,
        descripcion: data.descripcion,
        tipoCambio: data.tipoCambio,
        tipoCambioCompra: data.tipoCambioCompra !== 0 ? data.tipoCambioCompra : undefined,
      }
      const resp = await apiMonedaActualizar(input._id, monedaInput).catch((e) => {
        swalException(e)
        setFormLoading(false)
      })
      if (resp) {
        notSuccess('Moneda Actualizado correctamente')
        onClose(resp)
      }
      setFormLoading(false)
    } else {
      notError('Error obtención datos de la moneda')
    }
  }

  const onError = (error: any) => console.log(error)

  useEffect(() => {
    if (open) {
      if (input) {
        form.reset({
          ...input,
          sinMoneda: {
            codigoClasificador: input.codigo,
            descripcion: input.descripcion,
          },
        })
      }
    }
  }, [open, input])

  return (
    <Dialog
      maxWidth="sm"
      fullWidth
      id={id}
      keepMounted={keepMounted}
      open={open}
      {...other}
    >
      <DialogTitle>Actualizar Datos Moneda</DialogTitle>
      <DialogContent dividers>
        <MonedaForm
          form={form}
          action={actionForm.UPDATE}
          monedaPrimaria={monedaPrimaria}
        />
      </DialogContent>
      <DialogActions>
        <Button
          color={'error'}
          disabled={formLoading}
          onClick={() => {
            onClose()
          }}
        >
          Cerrar
        </Button>
        <Button
          variant={'contained'}
          size={'small'}
          color={'primary'}
          loading={formLoading}
          sx={{ mr: 2 }}
          onClick={() => form.handleSubmit(onSubmit, onError)()}
        >
          Actualizar Datos
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default MonedaActualizarDialog
